import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
export const PaymentURL = {
    payBankDetails: config.jmw + config.jmw_mf + "bank/details",
    paymentGateway: config.jmw + config.jmw_eq + "fund/paymentgatewayurl",
    tradePayment: config.jmw + config.jmw_mf + "trade/payment",
    orderStatus: config.jmw + config.jmw_mf + "order/payment/status"
};
